;(function($) {


    // Toggle footer part
    $('.js-footer-col').each(function () {
        var container = $(this),
            trigger = $(this).find('.footer__head'),
            content = $(this).find('.footer__content')

        $(trigger).click(function () {
            $(container).toggleClass('is-active')
            $(content).slideToggle(300)
        })
    })


}(jQuery));
